import React from 'react';
import styles from "./ErrorPage.module.css";
import {Typography} from "@mui/material";
import SignUpBannerFooter from "../../components/Footer/SignUpBannerFooter";
import {useNavigate} from "react-router-dom";

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.ErrorPage} data-testid="404" style={{background: '#FFF'}}>
      <section id="PageNotFoundTitle" className={styles.ErrorPageTitle} />

      <div className={styles.PageNotFound}>
        <div className={styles.PageNotFoundCard}>
          <div className={styles.PageNotFoundCardContent}>
            <Typography variant="h2" style={{color: '#1b1d37'}}>404 - Page not found</Typography>
            <br/>
            <Typography variant="body1" style={{textAlign: 'center'}}>
              The page you are looking for doesn't exist or has been moved. Please go back to the homepage.
            </Typography>
            <br/><br/>
            <button className={'PrimaryButton'} style={{width: '200px'}} onClick={() => navigate("/")}>Back to home</button>
          </div>
        </div>
      </div>

      <div style={{ height: '380px' }}></div>

      <SignUpBannerFooter />
    </div>
  );
};

export default PageNotFound;
